import { t } from '../../i18n/i18n';
import useCreateScreening from '../../hooks/useCreateScreening';
import UploadTestFiles from '../UploadTestFiles/UploadTestFiles';
import { TestFileType } from '../../constants/enums';
import { maxRecordTimes, maxPreparationTimes, maxAttemptsOptions } from '../../constants/questions';
import NewStyleSelect from '../NewStyleSelect/NewStyleSelect';

const QuestionDraw = ({ readOnly }) => {
  const {
    handleAddQuestionDraw,
    currentQuestionData,
    handleAddAnswerFile,
    handleRemoveAnswerFile,
    handleUpdateAnswerFile,
  } = useCreateScreening();

  return (
    <div data-testid="question-draw-container">
      <textarea
        type="text"
        onChange={(e) => handleAddQuestionDraw(e)}
        name="text"
        value={currentQuestionData?.text ?? ''}
        className={`w-100 mt-3 py-2 px-3  border-thin-blue-principal outline-none text-xs min-height-add-question ${
          currentQuestionData?.text?.length ? 'selected-border' : 'unselected-border'
        }`}
        rows="3"
        disabled={readOnly}
        maxLength={5000}
        placeholder={t('CREATE_SCREENING_YOUR_QUESTIONS_CODE_INPUT_PLACEHOLDER')}
        data-testid="question-code-add-question-textarea"
      />
      <UploadTestFiles
        fileTypes={[TestFileType.IMAGE]}
        maxFiles={1}
        handleAddFile={(file, type) => handleAddAnswerFile(0, file, type)}
        handleRemoveFile={(fileId) => handleRemoveAnswerFile(0, fileId)}
        handleUpdateFile={(fileId, dataToUpdate) => handleUpdateAnswerFile(0, fileId, dataToUpdate)}
        testFiles={currentQuestionData?.options?.[0]?.files ?? []}
        id="test"
        readOnly={readOnly}
      />
      <div className="d-flex justify-content-between align-items-center gap-3">
        <div
          data-testId="question-video-answer-total-time"
          className="justify-content-start d-flex flex-column w-100"
        >
          <div>
            <span className=" font-italic text-muted font-weight-bold text-xs">
              {t('CREATE_SCREENING_YOUR_QUESTIONS_VIDEO_TOTAL_RECORD_TIME')}
            </span>
          </div>
          <div>
            <NewStyleSelect
              error={false}
              className="w-100"
              disabled={readOnly}
              value={currentQuestionData?.totalTime ?? ''}
              options={maxRecordTimes}
              onChange={(e) => {
                handleAddQuestionDraw(e);
              }}
              name="totalTime"
              borderClasses="bottom-border text-center"
            />
          </div>
        </div>
        <div
          data-testId="question-video-answer-preparation-time"
          className="d-flex flex-column w-100 "
        >
          <div>
            <span className=" font-italic text-muted font-weight-bold text-xs">
              {t('CREATE_SCREENING_YOUR_QUESTIONS_VIDEO_PREPARATION_TIME')}
            </span>
          </div>
          <div>
            <NewStyleSelect
              error={false}
              className="w-100"
              disabled={readOnly}
              value={currentQuestionData?.preparationTime ?? ''}
              options={maxPreparationTimes}
              onChange={(e) => {
                handleAddQuestionDraw(e);
              }}
              name="preparationTime"
              borderClasses="bottom-border text-center"
            />
          </div>
        </div>
        <div
          data-testId="question-video-answer-max-attempts"
          className="justify-content-start d-flex flex-column w-100"
        >
          <div>
            <span className=" font-italic text-muted font-weight-bold text-xs">
              {t('CREATE_SCREENING_YOUR_QUESTIONS_VIDEO_MAX_ATTEMPTS')}
            </span>
          </div>
          <div>
            <NewStyleSelect
              error={false}
              className="w-100"
              disabled={readOnly}
              value={currentQuestionData?.maxAttempts ?? ''}
              options={maxAttemptsOptions}
              onChange={(e) => {
                handleAddQuestionDraw(e);
              }}
              name="maxAttempts"
              borderClasses="bottom-border text-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionDraw;
